// 51-cell US state checkbox grid: 50 states + DC. Single source of truth for
// the cell ordering — alphabetical by code so it's predictable and easy to
// scan. Cells render as 2-letter codes with a checkmark overlay when selected.

const ALL_STATE_CODES = [
  'AK', 'AL', 'AR', 'AZ', 'CA', 'CO', 'CT', 'DC', 'DE', 'FL',
  'GA', 'HI', 'IA', 'ID', 'IL', 'IN', 'KS', 'KY', 'LA', 'MA',
  'MD', 'ME', 'MI', 'MN', 'MO', 'MS', 'MT', 'NC', 'ND', 'NE',
  'NH', 'NJ', 'NM', 'NV', 'NY', 'OH', 'OK', 'OR', 'PA', 'RI',
  'SC', 'SD', 'TN', 'TX', 'UT', 'VA', 'VT', 'WA', 'WI', 'WV',
  'WY',
] as const

interface Props {
  selected: string[]
  onChange: (next: string[]) => void
  readOnly?: boolean
}

export default function StateGrid({ selected, onChange, readOnly = false }: Props) {
  const set = new Set(selected)

  function toggle(code: string) {
    if (readOnly) return
    const next = new Set(set)
    if (next.has(code)) next.delete(code)
    else next.add(code)
    // Always emit a sorted list so the wire-shape is stable.
    onChange([...next].sort())
  }

  function selectAll() {
    onChange([...ALL_STATE_CODES].sort())
  }

  function clear() {
    onChange([])
  }

  return (
    <div className={`ad-grid-wrap${readOnly ? ' is-read-only' : ''}`}>
      <div className="ad-grid-head">
        <span className="b-mono-dim b-tiny">{set.size} / {ALL_STATE_CODES.length} SELECTED</span>
        {!readOnly && (
          <div className="ad-grid-bulk">
            <button type="button" onClick={selectAll} className="b-btn-ghost b-btn-tiny">ALL</button>
            <button type="button" onClick={clear} className="b-btn-ghost b-btn-tiny">CLEAR</button>
          </div>
        )}
      </div>
      <div className="ad-grid">
        {ALL_STATE_CODES.map((code) => {
          const isOn = set.has(code)
          return (
            <button
              key={code}
              type="button"
              onClick={() => toggle(code)}
              disabled={readOnly}
              className={`ad-cell${isOn ? ' is-on' : ''}`}
              aria-pressed={isOn}
            >
              {code}
            </button>
          )
        })}
      </div>
    </div>
  )
}
